module.exports = __webpack_public_path__ + "img/frame (125).570b7ddd.jpg";